import { RootState } from "RootReducer";
import { ProductChooserKittedProducts } from "./ProductChooserReducer";

export const getProductChooserKittedDSKUDetails = (state: RootState): ProductChooserKittedProducts | undefined =>
  state.productChooser?.kittedProducts;
